// Add parallax effects
if (document.querySelector('.parallax')) {
  import('./components/parallax')
    .then(({ Parallax }) => {
      const parallax = new Parallax()
      parallax.init()
    })
}

// Add main-navigation functions
if (document.querySelector('.main-navigation')) {
  import('./components/main-navigation')
    .then(({ MainNavigation }) => {
      const mainNavigation = new MainNavigation()
      mainNavigation.init()
    })
}

// Add page-header functions
if (document.querySelector('.page-header')) {
  import('./components/page-header')
    .then(({ PageHeader }) => {
      const pageHeader = new PageHeader()
      pageHeader.init()
    })
}

// Add page--2 functions
if (document.querySelector('.page--2')) {
  import('./components/page-2')
    .then(({ Page2 }) => {
      const page2 = new Page2()
      page2.init()
    })
}

// Add big-teaser-1 functions
if (document.querySelector('.big-teaser--1')) {
  import('./components/big-teaser-1')
    .then(({ BigTeaser1 }) => {
      const bigTeaser1 = new BigTeaser1()
      bigTeaser1.init()
    })
}

// Add quote-1 functions
if (document.querySelector('.quote--1')) {
  import('./components/quote-1')
    .then(({ Quote1 }) => {
      const quote1 = new Quote1()
      quote1.init()
    })
}

// Add counter functions
if (document.querySelector('.counter')) {
  import('./components/counter')
    .then(({ Counter }) => {
      const counter = new Counter()
      counter.init()
    })
}

// Add video-box-1 functions
if (document.querySelector('.video-box--1')) {
  import('./components/video-box-1')
    .then(({ VideoBox1 }) => {
      const videoBox1 = new VideoBox1()
      videoBox1.init()
    })
}

// Add video-box-2 functions
if (document.querySelector('.video-box--2')) {
  import('./components/video-box-2')
    .then(({ VideoBox2 }) => {
      const videoBox2 = new VideoBox2()
      videoBox2.init()
    })
}

// Add video-box-3 functions
if (document.querySelector('.video-box--3')) {
  import('./components/video-box-3')
    .then(({ VideoBox3 }) => {
      const videoBox3 = new VideoBox3()
      videoBox3.init()
    })
}

// Add logo-slider-1 functions
if (document.querySelector('.logo-slider--1')) {
  import('./components/logo-slider-1')
    .then(({ LogoSlider1 }) => {
      const logoSlider1 = new LogoSlider1()
      logoSlider1.init()
    })
}

// Add teaser-list-4 functions
if (document.querySelector('.teaser-list--4')) {
  import('./components/teaser-list-4')
    .then(({ TeaserList4 }) => {
      const teaserList4 = new TeaserList4()
      teaserList4.init()
    })
}

// Add copy-buttons functions
if (document.querySelector('.button-copy-url')) {
  import('./components/copy-button')
    .then(({ CopyButton }) => {
      const copyButton = new CopyButton()
      copyButton.init()
    })
}

// Add dynamic select
if (document.querySelector('select, .dynamic-select')) {
  import('./components/dynamic-select')
    .then(({ DynamicSelect }) => {
      const dynamicSelect = new DynamicSelect()
      dynamicSelect.init()
    })
}

// Add select-Language functions
if (document.querySelector('.button-dropdown')) {
  import('./components/button-dropdown')
    .then(({ ButtonDropdown }) => {
      const buttonDropdown = new ButtonDropdown()
      buttonDropdown.init()
    })
}

// Add modal-1
if (document.querySelector('.modal--1')) {
  import('./components/modal-1')
    .then(({ Modal1 }) => {
      const modal1 = new Modal1()
      modal1.init()
    })
}

// Add form-3
if (document.querySelector('.form--3')) {
  import('./components/form-3')
    .then(({ Form3 }) => {
      const form3 = new Form3()
      form3.init()
    })
}

// Add slide-in-1
if (document.querySelector('.slide-in--1')) {
  import('./components/slide-in-1')
    .then(({ SlideIn1 }) => {
      const slideIn1 = new SlideIn1()
      slideIn1.init()
    })
}
